import React from 'react';
import {
  Container,
  Heading,
  Text,
  Stack,
  SimpleGrid,
  Wrap,
  WrapItem,
  Flex,
  Avatar,
} from '@chakra-ui/react';

const MeetNewPeople = () => {
  return (
    <Container maxW={'7xl'} py={{ base: 10, sm: 20, md: 32 }}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        <Stack spacing={4}>
          <Heading as={'h3'} mb={2} color={'red.400'}>
            Meet New People
          </Heading>
          <Text color={'gray.500'} maxW={'4xl'} fontSize={{ md: 'lg' }}>
            with complimentary skillset to collabrate on your next project.
            Message people to ask if they are available for collabration. Lets
            make networking less awkward by knowing people ahead of time.
          </Text>

          <Text color={'gray.500'} maxW={'4xl'} fontSize={{ md: 'lg' }}>
            Go ahead, and join community of people who attends Tech events.
          </Text>
        </Stack>

        <Flex justify={'center'} align={'center'}>
          <Wrap>
            <WrapItem>
              <Avatar name="Dan Abrahmov" src="https://bit.ly/dan-abramov" />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Tom Preston-Werner"
                src="https://avatars.githubusercontent.com/u/1?s=460&v=4"
              />
            </WrapItem>
            <WrapItem>
              <Avatar name="Kent Dodds" src="https://bit.ly/kent-c-dodds" />
            </WrapItem>
            <WrapItem>
              <Avatar name="Ryan Florence" src="https://bit.ly/ryan-florence" />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Guillermo Rauch"
                src="https://avatars.githubusercontent.com/u/13041?s=460&u=699b884e0e6b4d98630b05d69dc13e8d98f4ecc7&v=4"
              />
            </WrapItem>

            <WrapItem>
              <Avatar name="Segun Adebayo" src="https://bit.ly/sage-adebayo" />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Tanay Pratap"
                src="https://avatars.githubusercontent.com/u/10216863?s=460&u=1cfca84639b95bc43a1bd2f02038d3faf13dd719&v=4"
              />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="sanket sahu"
                src="https://avatars.githubusercontent.com/u/1733433?s=460&v=4"
              />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Pavithra Kodmad"
                src="https://avatars.githubusercontent.com/u/417268?s=460&u=df53b6066a9e8b86c92f4293ec3ee0ca0f485caa&v=4"
              />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Varsha saha"
                src="https://pbs.twimg.com/profile_images/1281873093841973250/1hIBkSLl_400x400.jpg"
              />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Akshay Saini"
                src="https://avatars.githubusercontent.com/u/12824231?s=460&u=1e32b260057cd53ffec00eb96aac8ec59626a5a1&v=4"
              />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Siddharth Kshetrapal"
                src="https://avatars.githubusercontent.com/u/1863771?s=400&u=b7094a6c2713eb7a985cac32fa10ccfdd79eac14&v=4"
              />
            </WrapItem>
            <WrapItem>
              <Avatar
                name="Yogesh yadav"
                src="https://avatars.githubusercontent.com/u/25588560?v=4"
              />
            </WrapItem>
          </Wrap>
        </Flex>
      </SimpleGrid>
    </Container>
  );
};

export default MeetNewPeople;
